import React from 'react'
import Status, { StatusType } from 'components/Shared/Status'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'

const StatusCell = (params: GridRenderCellParams) => {
    const isViewed = params.value
    return <Status type={isViewed ? StatusType.VIEWED : StatusType.NEW} />
}
export default StatusCell
